import React from 'react'
import { useAuth } from 'providers/auth-provider'

const normalize = (value) => String(value || '').trim().toLowerCase()
export const canOpenRoute = (route, user) => {
  const roles = route.allowedRoles || []
  const emails = route.allowedEmails || []
  return (!roles.length && !emails.length) || roles.some((role) => normalize(role) === normalize(user?.role)) || emails.some((email) => normalize(email) === normalize(user?.email))
}

export const protectRoute = (route) => {
  const Component = route.component
  const GuardedPage = (props) => {
    const { user, isLoading } = useAuth()
    if (isLoading) return <p role='status'>Memuat akses...</p>
    if (!user || !canOpenRoute(route, user)) return <div role='alert' className='alert alert-danger'>Anda tidak memiliki akses ke menu ini.</div>
    return <Component { ...props } />
  }
  return { ...route, component: GuardedPage }
}
